import groupBy from 'lodash/groupBy';

export function areasOfImprovementState(
  state = {
    areasOfImprovementById: {},
  },
  action
) {
  switch (action.type) {
    case 'RECEIVED_AREAS_OF_IMPROVEMENT': {
      const { areasOfImprovement } = action.value;
      const areasOfImprovementById = groupBy(areasOfImprovement, 'id')
      return { ...state, areasOfImprovement, areasOfImprovementById };
    }
    default: {
      return state;
    }
  }
}
